import { useQuery } from "@tanstack/react-query";
import { getRegistrationFormOptions } from "@/api/register.ts";

const useRegistrationFormOptions = () => {
	return useQuery({
		queryKey: ["registrationFormOptions"],
		queryFn: getRegistrationFormOptions,
	});
};

export default useRegistrationFormOptions;
